import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {create as createRecord} from "app/requests/admin/reviewers";
import {valueFrom, valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";
import usePrompt from "lib/hooks/use-prompt";
import {withoutBlankValues} from "lib/object";
import Form from "./form";

export default function AdminReviewersNew() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const [block, setBlock] = useState(false);
  const [record, setRecord] = useState({
    data: {},
    email: "",
    first_name: "",
    last_name: ""
  });

  usePrompt({when: block});

  const onChange = ({target}) => {
    setBlock(true);
    setRecord({...record, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    const updates = withoutBlankValues(record);

    setBlock(false);
    createRecord({record: updates}).then(({message, success}) => {
      if(success) {
        navigate("/admin/reviewers", {state: {message, type: "success"}});
      } else {
        dispatch(createNotification({content: message, type: "error"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({defaultValue, name, objects: [record]});

  return (
    <div className="container-fluid">
      <h1 className="text-center">New Reviewer</h1>
      <Form {...{onChange, onSubmit, value}} />
    </div>
  );
}
